<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted } from 'vue'
import { EmbedMessageType } from '@/helpers/embedHelper'
import appService from '@/services/appService'

const handleForceLogout = (e: MessageEvent) => {
  if (e.data?.type === EmbedMessageType.ForceLogout) {
    console.log('[StunnrUNI] Received FORCE_LOGOUT from parent, clearing protections.')
    window.onbeforeunload = null
    const instance = new appService()
    instance.clearAuthData(false)
  }
}

onMounted(() => {
  window.addEventListener('message', handleForceLogout)
})

onUnmounted(() => {
  window.removeEventListener('message', handleForceLogout)
})
</script>

<style>
body,
html {
  margin: 0;
  padding: 0;
  overflow: hidden !important;
  box-sizing: border-box;
  background: transparent !important;
}

#app {
  width: 100%;
  height: 100%;
  background: transparent !important;
}

.v-application {
  background: transparent !important;
}
</style>
